import '@/assets/styles/components/user-type-selector.styles.scss';
import React, { useEffect } from 'react';
import { ImageWithFallback } from '@/components';
import { UserTypeOption, UserTypeSelectorProps } from './user-type-selector.types';
import clsx from 'clsx';

export const UserTypeSelector: React.FC<UserTypeSelectorProps> = ({ selectedType, onChange, accountType }) => {
	const userTypes: UserTypeOption[] = [
		{
			value: 'COACH',
			label: 'Rehber Uzman',
			imageSrc: 'guide-expert.svg',
			imageAlt: 'Rehber Uzman'
		},
		{
			value: 'INSTRUCTOR',
			label: 'Branş Uzmanı',
			imageSrc: 'branch-teacher.svg',
			imageAlt: 'Branş Uzmanı'
		},
		{
			value: 'UNIVERSITY_STUDENT',
			label: 'Üniversite Öğrencisi',
			imageSrc: 'student.svg',
			imageAlt: 'Üniversite Öğrencisi'
		}
	];

	useEffect(() => {
		if (accountType) {
			const validType = userTypes.find(type => type?.value === accountType);
			if (validType) {
				onChange(validType?.value);
			}
		}
	}, [accountType]);

	return (
		<div className="user-types">
			{userTypes.map(type => (
				<label
					key={type.value}
					className={clsx('user-type', {
						selected: selectedType === type.value
					})}>
					<input
						type="radio"
						name="userType"
						value={type.value}
						checked={selectedType === type.value}
						onChange={() => onChange(type.value)}
					/>
					<div className="user-type__wrapper">
						<div className="user-type__image">
							<ImageWithFallback
								alt={type.imageAlt}
								src={type.imageSrc}
							/>
						</div>
						<span>{type.label}</span>
					</div>
					<div className="user-type__radio" />
				</label>
			))}
		</div>
	);
};
